import {
    CORRECTION_REQUEST, STAFF_KPI, CLOCK_IN_STATUS, STAFF_TRAINING_VIDEOS
} from './../actions/ActionTypes';
import InitialState from './InitialState';

const StaffDashboardReducer = (state = InitialState.staffDashboard, action) => {
    switch (action.type) {
        case STAFF_KPI: {
            let data = Object.assign({}, state);

            data.staffKPIList =  action.staffKPIList;
            return data;
        }

        case CLOCK_IN_STATUS: {
            let data = Object.assign({}, state);

            data.clockInStatus =  action.status;
            return data;
        }

        case CORRECTION_REQUEST: {
            let data = Object.assign({}, state);

            data.requests =  action.requests;
            return data;
        }

        case STAFF_TRAINING_VIDEOS: {
            return {
                ...state,
                trainingVideoList: [...action.videoList]
            }
        }

        default:
            return state;
    }
};

export default StaffDashboardReducer;



// WEBPACK FOOTER //
// ./src/reducers/StaffDashboardReducer.js